import React from 'react';
import PropTypes from 'prop-types';
import Typography from '../Typography';
import { StyledFaceBookShareButton, StyledImage } from './styles';
import ICON_FACEBOOK from './assets/icon-facebook.png';

/**
 * Facebook Share Button Component
 * @param {{
 * icon: string,
 * onClick: () => void,
 * wrapperClassName: string,
 * logoStyle: React.CSSProperties,
 * textColor: string,
 * height: string | number
 * } & import('../styled-system').SizingProps & import('../styled-system').ColorProps} props
 * @returns
 * @example 
 * <FacebookShareButton onClick={() => {}}/>
 */
const FacebookShareButton = ({
  icon,
  onClick,
  wrapperClassName,
  logoStyle,
  textColor,
  ...props
}) => (
  <div className={wrapperClassName}>
    <StyledFaceBookShareButton
      role="button"
      onClick={onClick}
      data-testid="facebook-share-button__wrapper"
      {...props}
    >
      <StyledImage
        src={icon}
        alt="facebook-icon"
        style={logoStyle}
        data-testid="facebook-share-button__image"
      />
      <Typography
        as="span"
        bold
        color={textColor}
        style={{ marginTop: 0 }}
        data-testid="facebook-share-button__text"
      >
        Bagikan Lewat Facebook
      </Typography>
    </StyledFaceBookShareButton>
  </div>
);

export default FacebookShareButton;

FacebookShareButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  wrapperClassName: PropTypes.string,
  logoStyle: PropTypes.object,
  textColor: PropTypes.string,
  icon: PropTypes.string.isRequired,
  height: PropTypes.number,
};

FacebookShareButton.defaultProps = {
  icon: ICON_FACEBOOK,
  wrapperClassName: '',
  logoStyle: {},
  textColor: 'white',
  height: 40,
};
